import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { AircraftEntity } from './aircraft.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum AircraftActionTypes {
  LoadAircrafts = '[Aircraft] Load Aircrafts',
  AddAircraft = '[Aircraft] Add Aircraft',
  UpsertAircraft = '[Aircraft] Upsert Aircraft',
  AddAircrafts = '[Aircraft] Add Aircrafts',
  UpsertAircrafts = '[Aircraft] Upsert Aircrafts',
  UpdateAircraft = '[Aircraft] Update Aircraft',
  UpdateAircrafts = '[Aircraft] Update Aircrafts',
  DeleteAircraft = '[Aircraft] Delete Aircraft',
  DeleteAircrafts = '[Aircraft] Delete Aircrafts',
  ClearAircrafts = '[Aircraft] Clear Aircrafts',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadAircrafts implements Action {
  public readonly type = AircraftActionTypes.LoadAircrafts;

  constructor(public payload: { aircrafts: AircraftEntity[] }) {}
}

export class AddAircraft implements Action {
  public readonly type = AircraftActionTypes.AddAircraft;

  constructor(public payload: { aircraft: AircraftEntity }) {}
}

export class UpsertAircraft implements Action {
  public readonly type = AircraftActionTypes.UpsertAircraft;

  constructor(public payload: { aircraft: AircraftEntity }) {}
}

export class AddAircrafts implements Action {
  public readonly type = AircraftActionTypes.AddAircrafts;

  constructor(public payload: { aircrafts: AircraftEntity[] }) {}
}

export class UpsertAircrafts implements Action {
  public readonly type = AircraftActionTypes.UpsertAircrafts;

  constructor(public payload: { aircrafts: AircraftEntity[] }) {}
}

export class UpdateAircraft implements Action {
  public readonly type = AircraftActionTypes.UpdateAircraft;

  constructor(public payload: { aircraft: Update<AircraftEntity> }) {}
}

export class UpdateAircrafts implements Action {
  public readonly type = AircraftActionTypes.UpdateAircrafts;

  constructor(public payload: { aircrafts: Update<AircraftEntity>[] }) {}
}

export class DeleteAircraft implements Action {
  public readonly type = AircraftActionTypes.DeleteAircraft;

  constructor(public payload: { id: string }) {}
}

export class DeleteAircrafts implements Action {
  public readonly type = AircraftActionTypes.DeleteAircrafts;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearAircrafts implements Action {
  public readonly type = AircraftActionTypes.ClearAircrafts;
}

export type AircraftActions =
  | LoadAircrafts
  | AddAircraft
  | UpsertAircraft
  | AddAircrafts
  | UpsertAircrafts
  | UpdateAircraft
  | UpdateAircrafts
  | DeleteAircraft
  | DeleteAircrafts
  | ClearAircrafts;
